import React, { useState, useEffect } from "react";
import { Typography, Grid, Button } from "@material-ui/core";
import { incidentsPending, loadAccountListAll } from "../utils/Actions";
import { GRID_DEFAULT_LOCALE_TEXT } from "../config/localeDatagrid";
import { Loading } from "../atoms";
import AccountBoxIcon from "@material-ui/icons/AccountBox";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment/min/moment-with-locales";
import { Link, useHistory } from "react-router-dom";
import Switch from "@material-ui/core/Switch";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default function Customers() {
  const [state, setstate] = useState([]);
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      setstate((await loadAccountListAll()).data);
    })();
  }, []);

  const ExportCSV = ({ csvData, fileName }) => {
    let datauserexport = [];

    csvData.map((item) => {
      const data = {
        IDCUENTA: item.id,
        CUENTA: item.name,
        NOMBRE: item.contactname,
        DIRECCION: item.address,
        TELEFONO: item.contactphone,
        CORREO: item.contactemail,
        FECHA_CREACION: item.createdAt,
        ESTATUS: item.status ? "ACTIVO" : "DESACTIVO",
      };
      datauserexport.push(data);
    });

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToCSV = (csvData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(datauserexport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => exportToCSV(csvData, fileName)}
      >
        Exportar a Excel
      </Button>
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "CUENTA",
      width: 200,
    },
    {
      field: "contactname",
      headerName: "Contácto",
      width: 200,
    },
    {
      field: "address",
      headerName: "Dirección",
      width: 250,
    },
    {
      field: "status",
      headerName: "Estatus",
      renderCell: (params) => (
        <Switch
          checked={params.value}
          color="primary"
          name="checkedB"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
      ),
      width: 150,
    },
    {
      field: "id",
      headerName: "Acciones",
      width: 120,
      renderCell: (params) => (
        <Link
          to={{
            pathname: `/editcustomer?id=${params.value}`,
            state: { id: params.value },
          }}
        >
          <EditIcon style={{ fontSize: 25 }} color="primary" />
        </Link>
      ),
      sortable: false,
    },
  ];

  const gotoCustomer = () => {
    history.push("/addcustomer");
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ justifyContent: "flex-end", height: 80 }}>
        <ExportCSV csvData={state} fileName={"Accounts"} />

        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: 20, marginLeft: 20 }}
          onClick={gotoCustomer}
        >
          Agregar Nueva Cuenta
        </Button>
      </GridToolbarContainer>
    );
  }

  return (
    <Grid
      container
      direction="column"
      style={{ height: "100vh", backgroundColor: "#fff", borderRadius: 5 }}
    >
      <Typography
        variant="h5"
        style={{
          marginBottom: 30,
          backgroundColor: "#fff",
          padding: 10,
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 5,
        }}
      >
        <AccountBoxIcon />
        Clientes
      </Typography>
      <DataGrid
        rows={state}
        columns={columns}
        autoPageSize={true}
        localeText={GRID_DEFAULT_LOCALE_TEXT}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <Loading visible={visible} setVisible={setVisible} />
    </Grid>
  );
}
